import moment from "moment/moment";

export default function previousDays(dates) {
  const dateObjects = dates.map((date) => new Date(date));

  const diffDays =
    (dateObjects[1] - dateObjects[0]) / (1000 * 60 * 60 * 24) + 1;
  const previousDates = dateObjects.map((date) => {
    const previousDate = new Date(date);
    previousDate.setDate(previousDate.getDate() - diffDays);
    return previousDate.toISOString().split("T")[0];
  });

  return previousDates;
}

export function previousDaysDifference(dates) {
  const dateObjects = dates.map((date) => new Date(date));

  // Calculate the difference in days between the two input dates
  return (dateObjects[1] - dateObjects[0]) / (1000 * 60 * 60 * 24) + 1;
}

export  function calculateDateDifference(input) {
  const { startDate, endDate, key } = input;

  // Convert date strings to Date objects
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);

  // Calculate the difference in milliseconds
  const dateDifference = endDateObj - startDateObj;

  // Create new startDate and endDate by subtracting the date difference
  const newStartDate = new Date(startDateObj.getTime() - dateDifference);
  const newEndDate = new Date(endDateObj.getTime() - dateDifference);

  // Format the new dates as ISO strings
  

  // Return the result
  return {
    newStartDate,
    newEndDate,
    key,
  };
}


export const getSpecificDataFormat = (date) => {
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear().toString().slice(-2);
  return `${day} ${month} ${year}`;
};


function getCurrencySymbol(countryCode, currencyCode) {
  try {
    const locale = `en-${countryCode.toUpperCase()}`;
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const parts = formatter.formatToParts(1);
    const symbolPart = parts.find(p => p.type === 'currency');
    return symbolPart ? symbolPart.value : currencyCode;
  } catch (e) {
    return "";
  }
}


export const numberFormatter = (
  value,
  isCurrencyFormat = false,
  type = "number",
  maximumFractionDigits = 2,
  compactConfig = {
    enabled: false,        // turn compact on/off
    formatAfterDigits: 4,  // start formatting after N digits
    digits: 1              // decimals after formatting
  }
) => {
  const { amazon_setup, flipkart_setup, myntra_setup } = JSON.parse(
    localStorage.getItem("clientData") || "{}"
  );
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));

  const SETUP_PLATFORMS = {
    amazon: amazon_setup,
    flipkart: flipkart_setup,
    myntra: myntra_setup,
  };
  
  if (type === "date") {
    return moment(value).format("ddd, MMM D, YYYY");
  }
  if (type === "week") {
    return moment(value, "YYYY-ww").format("[Week] ww, YYYY");
  }
  if(type === "month"){
    return moment(value, "YYYY-MM").format("MMM, YYYY");
  }



  // if value 2,14,74,83,647 then infinite symbol
  if (value === 2147483647 || value === -2147483648) {
    return "∞";
  }

  const countryCode =
    SETUP_PLATFORMS?.[userPlatform]?.profile_info?.countryCode || "IN";
  const currencyCode =
    SETUP_PLATFORMS?.[userPlatform]?.profile_info?.currencyCode || "INR";

  const applyCompactFormat = (num) => {
    if (
      !compactConfig?.enabled ||
      num.toString().length < compactConfig.formatAfterDigits
    ) {
      return null;
    }

    const units = [
      { value: 1_000_000, symbol: "M" },
      { value: 100_000, symbol: "L" },
      { value: 1_000, symbol: "K" },
    ];

    for (const unit of units) {
      if (num >= unit.value) {
        return (
          (num / unit.value)
            .toFixed(compactConfig.digits)
            .replace(/\.0+$/, "") + unit.symbol
        );
      }
    }
    return null;
  };

  // ✅ Currency
  if (
    isCurrencyFormat &&
    type === "number" &&
    value !== null &&
    value !== undefined
  ) {
    if (isNaN(value)) {
      return getCurrencySymbol(countryCode, currencyCode) + " " + value;
    }

    const compactValue = applyCompactFormat(value);
    if (compactValue) {
      return getCurrencySymbol(countryCode, currencyCode) + " " + compactValue;
    }

    return new Intl.NumberFormat(`en-${countryCode.toUpperCase()}`, {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits,
    })
      .format(value)
      .replace(/(\D)(\d)/, "$1 $2");
  }

  // ✅ Plain numbers
  if (
    !isCurrencyFormat &&
    type === "number" &&
    value !== null &&
    value !== undefined
  ) {
    if (isNaN(value)) return value;

    const compactValue = applyCompactFormat(value);
    if (compactValue) return compactValue;

    return new Intl.NumberFormat(`en-${countryCode.toUpperCase()}`, {
      maximumFractionDigits,
    }).format(value);
  }

  // ✅ Percent
  if (type === "percent" && value !== null && value !== undefined) {
    if (isNaN(value)) return value + "%";

    return (
      new Intl.NumberFormat(`en-${countryCode.toUpperCase()}`, {
        maximumFractionDigits,
      }).format(value) + "%"
    );
  }

  return value;
};



export const isPlatformMatch = (allowedPlatforms = []) => {
  if (!allowedPlatforms || !Array.isArray(allowedPlatforms) || allowedPlatforms.length === 0) {
    return false;
  }
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  return allowedPlatforms.includes(userPlatform);
}


